import { Loader2 } from "lucide-react";

export function Loader({ label }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 text-sm text-brand-muted"
    >
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      <span>{label ?? "Loading..."}</span>
    </div>
  );
}
